import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { Table, Button, Modal, Form } from 'react-bootstrap';
import { FiEdit, FiTrash2, FiPlusCircle } from 'react-icons/fi';

const CategoriasView = () => {
  const [categorias, setCategorias] = useState([]);
  const [nombre, setNombre] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const business = JSON.parse(localStorage.getItem('business'));
  const businessId = business?.id;

  const fetchCategorias = async () => {
    try {
      const res = await api.get(`/categories?business_id=${businessId}`);
      setCategorias(res.data);
    } catch (error) {
      console.error('Error al obtener categorías:', error);
    }
  };

  useEffect(() => {
    fetchCategorias();
  }, []);

  const resetForm = () => {
    setNombre('');
    setEditingId(null);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      if (editingId) {
        await api.put(`/categories/${editingId}`, { name: nombre });
      } else {
        await api.post('/categories', { name: nombre, business_id: businessId });
      }
      fetchCategorias();
      resetForm();
      setShowModal(false);
    } catch (error) {
      console.error('Error al guardar categoría:', error);
    }
  };

  const handleEdit = cat => {
    setNombre(cat.name);
    setEditingId(cat.id);
    setShowModal(true);
  };

  const handleDelete = async id => {
    if (window.confirm('¿Seguro que querés eliminar esta categoría?')) {
      try {
        await api.delete(`/categories/${id}`);
        fetchCategorias();
      } catch (error) {
        console.error('Error al eliminar categoría:', error);
      }
    }
  };

  return (
    <div className="p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">📦 Categorías</h4>
        <Button variant="success" onClick={() => { resetForm(); setShowModal(true); }}>
          <FiPlusCircle className="me-2" />
          Nueva categoría
        </Button>
      </div>

      <Table responsive bordered hover>
        <thead className="table-light">
          <tr>
            <th>Nombre</th>
            <th style={{ width: '200px' }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {categorias.map(cat => (
            <tr key={cat.id}>
              <td>{cat.name}</td>
              <td>
                <Button size="sm" variant="outline-warning" className="me-2" onClick={() => handleEdit(cat)}>
                  <FiEdit className="me-1" /> Editar
                </Button>
                <Button size="sm" variant="outline-danger" onClick={() => handleDelete(cat.id)}>
                  <FiTrash2 className="me-1" /> Eliminar
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editingId ? 'Editar categoría' : 'Nueva categoría'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                value={nombre}
                onChange={e => setNombre(e.target.value)}
                required
              />
            </Form.Group>
            <div className="d-flex justify-content-end">
              <Button variant="secondary" className="me-2" onClick={() => setShowModal(false)}>
                Cancelar
              </Button>
              <Button type="submit" variant="success">
                {editingId ? 'Actualizar' : 'Guardar'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CategoriasView;
